module.exports = __webpack_public_path__ + "img/2566-09-0409.54.39.e0bdd29f.jpg";